import { useAuth } from "@/hooks/useAuth";
import UnauthenticatedNav from "./UnauthenticatedNav";
import AuthenticatedNav from "./AuthenticatedNav";

const Header = () => {
  const { user, isLoading } = useAuth();

  console.log("Header: user =", user, "isLoading =", isLoading); // Debug log

  if (isLoading) {
    return (
      <header className="border-b border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 sticky top-0 z-50">
        <div className="container mx-auto px-4 h-16 flex items-center justify-center">
          <div className="w-6 h-6 border-2 border-primary border-t-transparent rounded-full animate-spin" />
        </div>
      </header>
    );
  }

  return (
    <header className="border-b border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 sticky top-0 z-50">
      <div className="container mx-auto px-4 h-16 flex items-center w-full">
        {user ? <AuthenticatedNav /> : <UnauthenticatedNav />}
      </div>
    </header>
  );
};

export default Header;